declare var io: any;
export const environment = {
  production: true,
  googleAnalyticsId: 'G-32ZMN8218F',


  apiURL: 'https://www.kawawadigitalsolution.com:8020/',
  baseUrl: 'https://www.kawawadigitalsolution.com:8020/',
  socketUrl: 'https://www.kawawadigitalsolution.com:8020/',
  callBackUrl: 'https://www.kawawamotors.com/'

  // apiURL: 'https://www.kawawamotorsapi.acelance.com:8020/',
  // baseUrl: 'https://www.kawawamotorsapi.acelance.com:8020/',
  // socketUrl: 'https://www.kawawamotorsapi.acelance.com:8020/',
  // callBackUrl: 'https://www.kawawamotorsweb.acelance.com/',

  // apiURL: 'https://www.kawawamotorsapi.acelance.com/', 
  // baseUrl: 'https://www.kawawamotorsapi.acelance.com/',
  // socketUrl : 'https://www.kawawamotorsapi.acelance.com/',

};

